var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import FetchService from "./Shared/FetchService";
import WorkflowNodeDomainService from "../Domain/WorkflowNode/WorkflowNode.service";
import { WorkflowGroupDomainService } from "../Domain/WorkflowGroup/WorkflowGroup.service";
const BASE_URL = "/aviso/workflowGroup";
export default class WorkflowGroupService {
    static statistics(workflowGroupId) {
        return FetchService.getSingleResponse(BASE_URL + "/statistics", {
            workflowGroupId,
        });
    }
    static nodeDefinitions(workflowGroupId) {
        return FetchService.getSingleResponse(BASE_URL + "/nodeDefinitions", {
            workflowGroupId,
        });
    }
    static nodes(workflowGroupId, options = {}) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const nodes = yield FetchService.getPagedResponse(BASE_URL + "/nodes", {
                workflowGroupId,
                externalStatusIds: options.externalStatusIds,
                workflowNodeStatusIds: options.workflowNodeStatusIds,
                referenceId: options.referenceId,
                max: options.max,
                offset: options.offset,
                order: options.order,
                direction: options.direction,
            });
            return Object.assign(Object.assign({}, nodes), { 
                // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                data: (_a = nodes.data) === null || _a === void 0 ? void 0 : _a.map(WorkflowNodeDomainService.fromJSON) });
        });
    }
    static getChooseableWorkflowNodeDefinitions() {
        return FetchService.getSingleResponse(BASE_URL + "/getChooseableWorkflowNodeDefinitions");
    }
    static edit({ workflowNodeDefinitions, connections, rootNode, workflowGroupId, lastModifiedDate, }) {
        return FetchService.postSingleResponse(BASE_URL + "/edit", {
            workflowNodeDefinitions,
            connections,
            rootNode,
            workflowGroupId,
            lastModifiedDate,
        }).then(WorkflowGroupDomainService.fromJSON);
    }
    static create({ workflowNodeDefinitions, connections, rootNode, attachableType, attachableId, }) {
        return FetchService.postSingleResponse(BASE_URL + "/create", {
            workflowNodeDefinitions,
            connections,
            rootNode,
            attachableType,
            attachableId,
        }).then(WorkflowGroupDomainService.fromJSON);
    }
}
